<template>
  <!--<div class="app-content content">
    <div class="content-wrapper">
      <div class="content-header row"></div>
      <div class="content-body">
        <section class="flexbox-container">-->
          <router-view></router-view>
        <!--</section>
      </div>
    </div>
  </div>-->
</template>

<script>

export default {
  mounted() {
    /*let body = document.querySelector("body");
    body.setAttribute("data-open","click");
    body.setAttribute("data-menu","vertical-menu");
    body.setAttribute("data-col","1-column"); 
    $("body").addClass("vertical-layout vertical-menu 1-column bg-cyan bg-lighten-2 menu-expanded fixed-navbar");*/
  },
};
</script>



// WEBPACK FOOTER //
// src/layouts/auth/MainLogin.vue